/**
 * Creating a global variable to CRUD cookies for the application
 */
Shopify.Cookies = {
  set: function (name, value, days = 7) {
    let cookie = {
      [name]: JSON.stringify(value),
      path: '/',
    };

    if (days) {
      let date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      cookie.expires = date.toUTCString();
    }

    let arr = [];
    for (let key in cookie) {
      arr.push(`${key}=${cookie[key]}`);
    }

    document.cookie = arr.join('; ');

    return this.get(name);
  },

  getAll: function () {
    let cookie = {};

    document.cookie.split(';').forEach((el) => {
      let [k, ...v] = el.split('=');
      cookie[k.trim()] = v.join('=');
    });
      
    return cookie;
  },

  get: function (name) {
    const result = this.getAll()[name];

    if(result) {
      return JSON.parse(result);
    }
  },

  delete: function (name) {
    this.set(name, '', -1);
  },

  remove: function (name) {
    this.delete(name);
  }
};

/**
 * Creating a global variable to CRUD cookies for the application
 */
Shopify.LocalStorage = {
  set: function (name, value) {
    window.localStorage.setItem(name, JSON.stringify(value));
    return this.get(name);
  },

  get: function (name) {
    const result = window.localStorage.getItem(name)
    if(result) {
      return JSON.parse(result);
    }
  },

  delete: function (name) {
    window.localStorage.removeItem(name);
  },

  remove: function (name) {
    this.delete(name);
  }
};

//When no products are found in URL, then remove it
if (!window.location.href.includes("/products/")) {
  //Variables
  const cookieProducts = 'rechargebundle_products';
  const cookieFilters = 'rechargebundle_filters';

  //Clears the cookies from existence
  Shopify.LocalStorage.remove(cookieProducts);
  Shopify.LocalStorage.remove(cookieFilters);
}